import React from 'react';
import PropTypes from 'prop-types';
import {
  UsageProgressGauge,
  UsageProgressGaugeCollapsed,
} from '@saucelabs/sl-component-gauges';
import { Typography } from '@saucelabs/ds-typography';

const UsageSessionChart = ({
  collapsed,
  collapsedChartLabel,
  current,
  label,
  limit,
  tooltipLabel,
  onClick,
}) => {
  if (collapsed) {
    return (
      <UsageProgressGaugeCollapsed
        collapsedChartLabel={collapsedChartLabel}
        current={current}
        label={tooltipLabel}
        limit={limit}
        onClick={onClick}
      >
        <Typography
          className="text-high-emphasis font-semibold"
          variant="body-small"
        >
          {current}
        </Typography>
      </UsageProgressGaugeCollapsed>
    );
  }

  // !collapsed
  return (
    <UsageProgressGauge
      current={current}
      label={label}
      limit={limit}
      onClick={onClick}
    >
      <Typography
        className="font-semibold"
        variant="body-small"
      >
        <span className="text-high-emphasis">{current}</span>
        {`/${limit}`}
      </Typography>
    </UsageProgressGauge>
  );
};

UsageSessionChart.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  collapsedChartLabel: PropTypes.string.isRequired,
  current: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  label: PropTypes.string.isRequired,
  limit: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onClick: PropTypes.func,
  tooltipLabel: PropTypes.node.isRequired,
};

UsageSessionChart.defaultProps = {
  onClick: undefined,
};

export default UsageSessionChart;
